function LegalPage({ title, updatedAt, children }) {
    return (
        <div className="legal general-wrapper">
            {title}

            <div className="legal__content card-common">
                <p className="legal__updated">{updatedAt}</p>
                {children}
            </div>
        </div>
    );
}

export default LegalPage;
